import { render, staticRenderFns } from "./HighwayApprove.vue?vue&type=template&id=45c11cbf"
import script from "./HighwayApprove.vue?vue&type=script&lang=js"
export * from "./HighwayApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports